import React, { useEffect } from "react";
import { FormLayoutHandler } from "../layouts/FormLayoutHandler";
import { VERSION } from "../../constants/webapp";
import { FormHandlerWrapper } from "../../components/styled/StyledComponents";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { VERSION_REF } from "../../constants/api";

export const VersionControlForm = () => {
  const { getDocData, data, loading } = useFirebase();

  // get data
  useEffect(() => {
    getDocData(VERSION_REF);
  }, []);

  return (
    <FormHandlerWrapper className="whiteBg radius6">
      <FormLayoutHandler
        key={VERSION}
        source={VERSION}
        data={data}
        loading={loading}
      />
    </FormHandlerWrapper>
  );
};
// VERSION_REF
